module.exports = __webpack_public_path__ + "static/img/Reece-Walsh.59643c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Reece-Walsh.jpg
// module id = 8gfZ
// module chunks = 0